<template>
  <div class="localization">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-12">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row align-items-center">
                  <div class="col">
                    <h3 class="page-title">Widget Chat</h3>
                    <ul class="breadcrumb">
                      <li class="breadcrumb-item">
                        <router-link to="/index">Dashboard</router-link>
                      </li>
                      <li class="breadcrumb-item">
                        <router-link to="/toolkit/widget/list">Widget Chat</router-link>
                      </li>
                      <li class="breadcrumb-item active">View</li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- {{viewArr}} -->
              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group row">
                            <div class="input-group" style="margin-left:10px;">
                              <span
                                style="display:none;"
                                ref="renderScript"
                                v-html="viewArr.widget_script"
                              ></span>
                              <textarea
                                style="height:300px"
                                ref="textareaScript"
                                aria-label
                                aria-describedby="basic-addon2"
                                class="form-control js-copytextarea"
                                readonly
                              ></textarea>
                              <div class="input-group-append">
                                <button type="button" class="btn btn-primary js-textareacopybtn">
                                  <i class="fa fa-copy"></i> Copy
                                </button>
                              </div>
                            </div>
                          </div>
                          <p>
                            <span
                              class="text-muted"
                            >Copy and Paste this code into &lt;head&gt; or before &lt;/body&gt;</span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="row">
                            <div class="col-md-8">
                              <table class="table">
                                <tbody>
                                  <tr>
                                    <td style="width:30%;">Header Title</td>
                                    <td>: {{viewArr.title}}</td>
                                  </tr>
                                  <tr>
                                    <td style="width:30%;">Website</td>
                                    <td>: {{viewArr.domain}}</td>
                                  </tr>
                                  <tr>
                                    <td>Operator</td>
                                    <td>: {{viewArr.num_operator}}</td>
                                  </tr>
                                  <tr>
                                    <td>Widget Mode</td>
                                    <td>: {{viewArr.mode_widget}}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="col-md-4">
                              <p v-if="viewArr.is_publish==1">
                                Status:
                                <label class="badge badge-success">Published</label>
                              </p>
                               <p v-if="viewArr.is_publish==0">
                                Status:
                                <label class="badge badge-warning">Draft</label>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
// import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import LayoutSidebarPromotion from "@/components/layouts/Sidebar.vue";

import VueSimpleAlert from "vue-simple-alert";
import { downloadImage } from "@/utils/helper";
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion,
    QrcodeVue
  },
  computed: {
    memberSession() {
      return this.$store.state.login.memberSession;
    },
    isJoinAffiliate() {
      return this.$store.state.referral.isJoin;
    }
  },
  data() {
    return {
      appTitle: process.env.VUE_APP_TITLE,
      isLoading: false,
      isLoadingImages: false,
      isLoadingInfo: false,
      referralLink: "",
      imgArr: [],
      infoArr: {
        id: 0,
        referral_code: "",
        referral_join_datetime: 0,
        referral_bonus: 0,
        target_omzet: 0,
        update_datetime: 0
      },
      viewArr: {
        id: "",
        member_id: 0,
        widget_key: "",
        widget_script: "",
        title: "",
        domain: "",
        mode_widget: "",
        fb_pixel_id: "",
        fb_pixel_event: "",
        fb_pixel_currency: "",
        fb_pixel_amount: 0,
        g_tag_id: "",
        is_publish: 1,
        num_clicks: 0,
        num_operator: 0
      }
    };
  },
  async created() {
    let id = "";
    if (
      typeof this.$route.query.id != "undefined" &&
      this.$route.query.id != ""
    ) {
      id = this.$route.query.id;
    } else {
      this.$router.push("/toolkit/widget/list");
      return;
    }
    console.log("iddd", id);
    this.view(id);
    this.info();
    this.shareLink();
    this.images();
    if (this.isJoinAffiliate == false) {
      this.$router.push({ path: "/referral" });
    }
  },
  methods: {
    downloadImage(url, title) {
      return downloadImage(url, title);
    },
    view(id) {
      this.isLoadingInfo = true;
      this.$store
        .dispatch("toolkit/detailWidgetChat", id)
        .then(response => {
          this.isLoadingInfo = false;
          this.viewArr = response.data;
          var that = this;
          setTimeout(function() {
            let renderValue = that.$refs.renderScript.innerHTML;
            that.$refs.textareaScript.innerHTML = renderValue;
            console.log("renderValue", renderValue);
          }, 300);
        })
        .catch(() => {
          this.isLoadingInfo = false;
        });
    },
    info() {
      this.isLoadingInfo = true;
      this.$store
        .dispatch("referral/info")
        .then(response => {
          this.isLoadingInfo = false;
          this.infoArr = response.data;
        })
        .catch(() => {
          this.isLoadingInfo = false;
        });
    },
    images() {
      this.isLoadingImages = true;
      this.$store
        .dispatch("referral/images")
        .then(response => {
          this.isLoadingImages = false;
          this.imgArr = response.data;
        })
        .catch(() => {
          this.isLoadingImages = false;
        });
    },
    shareLink() {
      this.isLoading = true;
      this.$store
        .dispatch("referral/shareLink")
        .then(response => {
          this.isLoading = false;
          this.referralLink = response.data;
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  },
  mounted() {
    var copyTextareaBtn = document.querySelector(".js-textareacopybtn");

    copyTextareaBtn.addEventListener("click", function(event) {
      var copyTextarea = document.querySelector(".js-copytextarea");
      copyTextarea.focus();
      copyTextarea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        if (successful) {
          VueSimpleAlert.fire({
            title: "Success",
            text: "Copied successfully!",
            type: "success",
            timer: 3000
          });
        }
        // console.log("Copying text command was " + msg);
      } catch (err) {
        // console.log("Oops, unable to copy");
        VueSimpleAlert.fire({
          title: "Success",
          text: "Copied successfully!",
          type: "success",
          timer: 3000
        });
      }
    });

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "referral"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/widget/view.vue